module.exports = __webpack_public_path__ + "static/media/qr-phonepay.93856bb2.svg";